import { NgModule } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import { UniversalModalModule } from "@modules/+new/shared/universal-modal/universal-modal.module";
import { CashPlusOptInComponent } from "@modules/cashplus/features/opt-in/cashplus-optin.component";
import { CashPlusOptOutComponent } from "@modules/cashplus/features/opt-out/cashplus-optout.component";
import { BpModalIntroScreenModule } from "@modules/shared/bp-modal-intro-screen/bp-modal-intro-screen.module";
import { StocksModule } from "@modules/main/components/stocks/stocks.module";
import { CashplusPortfolioWidgetComponent } from "@modules/cashplus/ui/cashplus-portfolio-widget/cashplus-portfolio-widget.component";
import { BpPillInfoModule } from "@modules/shared/bp-pill-info/bp-pill-info.module";
import { ToggleInputModule } from "@modules/shared/bp-toggle/toggle-input.module";
import { CashplusCurrentRateInfoModalComponent } from "@modules/cashplus/ui/cashplus-current-rate-info-modal/cashplus-current-rate-info-modal.component";
import { CashplusRollInfoModalComponent } from "@modules/cashplus/ui/cashplus-roll-info-modal/cashplus-roll-info-modal.component";
import { A11yModule } from "@angular/cdk/a11y";
import { WalletCashOutComponent } from "@modules/cashplus/features/wallet/wallet-cash-out.component";
import { CashPlusTrackingFacade } from "@modules/cashplus/+state/cashplus-tracking.facade";
import { TermsAndConditionsUpdatesModule } from "@modules/shared/terms-and-conditions/components/terms-and-conditions-updates.module";

const DECLARATIONS = [
	CashPlusOptInComponent,
	CashPlusOptOutComponent,
	CashplusPortfolioWidgetComponent,
	CashplusCurrentRateInfoModalComponent,
	CashplusRollInfoModalComponent,
	CashplusPortfolioWidgetComponent,
	WalletCashOutComponent
];
const MODULES = [
	CoreModule,
	UniversalModalModule,
	BpModalIntroScreenModule,
	StocksModule,
	ToggleInputModule,
	BpPillInfoModule,
	A11yModule,
	TermsAndConditionsUpdatesModule
];

@NgModule({
	imports: [...MODULES],
	exports: [...DECLARATIONS],
	providers: [CashPlusTrackingFacade],
	declarations: [...DECLARATIONS]
})
export class CashPlusModule {}
